<core-helpers-box-alert-message-icon [hidden]="files.length > 0"
        [text]="'There are no files attached to this project yet.'"
        [icon]="'no_linked'"
    ></core-helpers-box-alert-message-icon>
<div class="attachments-active-list">
    <core-signed-files-list
        [files]="files"
        [notes]="notes"
        [menu]="menu"
        [scope]="'default'"
        (menuClick)="onMenuClick($event)"
        (actionClick)="actionClick.emit($event)"
        (iconDownloadClick)="onActionDownloadClick($event)"
        (refreshSignaturesNeeded)="onRefreshSignaturesNeeded()"
    ></core-signed-files-list>
</div>
